import moment from 'moment'
import get from 'lodash/get'
import pick from 'lodash/pick'

import querystring from 'query-string'

export function generateFlexDatesQuery({
  requestObj = {},
  // eslint-disable-next-line no-unused-vars
  tripType,
  rangePlusMinus = 3,
}) {
  const cabinClass = get(requestObj, 'params[cabin-class]', 'ECO')
  const numAdults = parseInt(get(requestObj, 'params[num-adults]', 0))
  const numYouths = parseInt(get(requestObj, 'params[num-youths]', 0))

  // Only add default adult passenger if no unaccompanied minors
  if (numAdults < 1 && numYouths < 1) {
    requestObj.params['num-adults'] = 1
  }

  const passengerUrl = querystring.stringify(
    pick(requestObj.params, [
      'num-youths',
      'num-adults',
      'num-children',
      'num-infants',
    ])
  )

  const showOnly = [
    'origins',
    'destinations',
    'cabinClass',
    'paxAdult',
    'paxChild',
    'paxInfant',
    'viewers',
    'dates',
    'minimumFare',
  ]

  const defaultQueryOptions = {
    slices: [],
    rangePlusMinus,
    airports: {},
    showOnly,
    size: 180,
    sopq: false,
    useLOS: false,
    useCurrentDateReference: false,
  }

  const query = buildElasticSearchQuery({
    ...defaultQueryOptions,
    ...{
      slices: requestObj.slices,
      rangePlusMinus,
      airports: requestObj.airports || {},
      // plfCode: requestObj.plfCode || 'PCLN',
    },
  })
  query.cabinClass = cabinClass

  return {
    query,
    passengerUrl,
  }
}

export function buildElasticSearchQuery(options) {
  const {
    slices,
    rangePlusMinus,
    airports,
    showOnly,
    size,
    sopq,
    useLOS,
    useCurrentDateReference,
    // plfCode,
  } = options

  let departDate = null

  const trips = slices.map((slice, index) => {
    const returnMap = {}

    if (
      airports[slice.originAirport] &&
      airports[slice.originAirport].cityCode === slice.originAirport
    ) {
      returnMap.originCity = [slice.originAirport]
    } else {
      returnMap.origin = [slice.originAirport]
    }

    if (
      airports[slice.destinationAirport] &&
      airports[slice.destinationAirport].cityCode === slice.destinationAirport
    ) {
      returnMap.destinationCity = [slice.destinationAirport]
    } else {
      returnMap.destination = [slice.destinationAirport]
    }

    if (index === 0 || !useLOS) {
      departDate = slice.travelDate
      let rangeDate = departDate
      if (useCurrentDateReference) {
        const currentDate = moment()
          .set('hour', 0)
          .set('minute', 0)
          .set('second', 0)
          .set('millisecond', 0)
        const diff = moment(slice.travelDate).diff(currentDate, 'days')
        rangeDate =
          diff >= rangePlusMinus
            ? slice.travelDate
            : currentDate.add(rangePlusMinus, 'days').format('YYYY-MM-DD')
      }

      returnMap.departDateRange = {
        fromDate: rangeDate,
        rangePlusMinus,
      }
    } else {
      const lengthOfStay = moment(slice.travelDate).diff(departDate, 'days')
      returnMap.lengthOfStay = [lengthOfStay]
    }

    return returnMap
  })

  return {
    trips,
    showOnly,
    sopq,
    size,
    consumer: 'PCLN-FLIGHTS',
    // plfCode,
  }
}

export function numberOfViewersQuery({ cityCode, airportCode, travelDate }) {
  const flexDatesQuery = {
    trips: [
      {
        originCity: ['*'],
        departDate: travelDate,
      },
    ],
    showOnly: ['viewers'],
    size: 180,
    consumer: 'PCLN-FLIGHTS',
  }

  if (cityCode !== airportCode) {
    flexDatesQuery.trips[0].destination = [airportCode]
  } else {
    flexDatesQuery.trips[0].destinationCity = [cityCode]
  }

  return flexDatesQuery
}
